import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'recognition_audio';

export default {
  async getTranscription(file) {
    const url = mountUrl(`/${BASE_PATH}/get-transcription`);
    return api.post(url, file);
  }
};
